import React, { useEffect } from 'react'
import Icon from '../icon'
import { ActionButton, CloseButton, Alert, Text, Wrapper } from './styles'

type Props = {
  'data-qa'?: string
  autoHideDuration?: number
  buttonText?: string
  isOpen?: boolean
  onClose?: () => void
  priority: 'low' | 'high'
  text: string
  theme: 'neutral' | 'negative' | 'warning' | 'positive'
}

const Snackbar: React.FC<Props> = (props: Props): JSX.Element => {
  const dataQa = props['data-qa'] || `snackbar-${props.theme}`

  useEffect(() => {
    props.isOpen &&
      !Boolean(props.buttonText) &&
      autoHide(props.onClose, props.autoHideDuration)
  })

  return (
    <Wrapper data-qa={dataQa}>
      {props.isOpen && (
        <Alert className={`${props.theme} ${props.priority}-priority`}>
          {props.theme && (
            <Icon name={variantIcon[props.theme]} data-qa={`${dataQa}-icon`} />
          )}

          <Text data-qa={`${dataQa}-text`}>{props.text}</Text>

          {!props.buttonText && (
            <CloseButton
              onClick={() => props.onClose()}
              aria-label="Fechar"
              data-qa={`${dataQa}-close-button`}
            >
              <Icon name="close" />
            </CloseButton>
          )}

          {props.buttonText && (
            <ActionButton
              className={`${props.theme} ${props.priority}-priority`}
              onClick={() => props.onClose()}
              data-qa={`${dataQa}-action-button`}
            >
              {props.buttonText}
            </ActionButton>
          )}
        </Alert>
      )}
    </Wrapper>
  )
}

Snackbar.defaultProps = {
  priority: 'high',
  theme: 'neutral',
  isOpen: false,
  autoHideDuration: 3000,
}

export default Snackbar

const variantIcon = {
  neutral: 'info',
  negative: 'error',
  warning: 'warning',
  positive: 'check_circle',
}

function autoHide(onClose: Function, autoHideDuration: number) {
  setTimeout(function () {
    onClose()
  }, autoHideDuration)
}
